// Entry point for the redesigned site. App.js renders <SarvagunaApp />.
// On start it loads the text saved in the admin (falls back to content.js).
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles.css';
import { Layout } from './components';
import { loadLiveContent } from './liveContent';
import {
  Home, WhatWeDo, Service, HowWeWork, Partner, Academy, About, ContactPage,
  Stories, Story, NotFound,
} from './pages';

const Admin = lazy(() => import('./admin/Admin'));

function Site() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/what-we-do/:slug" element={<Service />} />
        <Route path="/how-we-work" element={<HowWeWork />} />
        <Route path="/partner-with-us" element={<Partner />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/stories/:slug" element={<Story />} />
        {/* Old one-page anchors and likely old links */}
        <Route path="/services" element={<Navigate to="/what-we-do" replace />} />
        <Route path="/impact" element={<Navigate to="/how-we-work" replace />} />
        <Route path="/partners" element={<Navigate to="/about#partners" replace />} />
        <Route path="/team" element={<Navigate to="/about#team" replace />} />
        <Route path="/blog" element={<Navigate to="/stories" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default function SarvagunaApp() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    loadLiveContent().finally(() => setReady(true));
  }, []);
  if (!ready) return <div className="sg" aria-busy="true" />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<Suspense fallback={null}><Admin /></Suspense>} />
        <Route path="*" element={<Site />} />
      </Routes>
    </BrowserRouter>
  );
}
